'use client';

import { useEffect, useRef } from 'react';
import { useVisible } from '@/hooks';
import styles from './personalLoansVideo.module.scss';

export const PersonalLoansVideo = () => {
  const [isVisible, id] = useVisible();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      if (isVisible) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [isVisible]);

  return (
    <article id={id} className={styles.wrapper}>
      <video
        ref={videoRef}
        className={`${styles.video} ${isVisible ? styles.isVisible : ''}`}
        loop
        muted
        playsInline
      >
        <source
          src="/static/video/personal-loans-slice-HD.mp4"
          type="video/mp4"
        />
      </video>
    </article>
  );
};
